import { Icon } from '@platform/components';
import { Link } from 'wouter';

type ViewAllCardProps = {
  link: string;
};

export const ViewAllCard = (props: ViewAllCardProps) => {
  const { link } = { ...props };
  return (
    <div className='flex justify-center items-center p-4 last:pb-0 first:pt-0 w-full'>
      <Link
        className='text-brand-500 font-semibold w-full flex flex-row justify-center items-center'
        href={link}
      >
        View all&nbsp;
        <Icon type='arrow-right' size='18' additionalClassNames='mt-0.5' />
      </Link>
    </div>
  );
};
